export const BuildInfo = {timestamp:1791221723000}
